import React from "react";
import moment from "moment";
import PAGE_CONSTANTS from "../constant";
const addressRegex = /^[a-zA-Z0-9\s.,#()\\\-\/]+$/;
const cityRegex = /^[a-zA-Z\s]+$/;
const mobileRegex = /^(\+\d{1,3}[- ]?)?\d{10}$/;
const emailRegex = /[A-Za-z0-9\._%+\-]+@[A-Za-z0-9\.\-]+\.[A-Za-z]{2,}$/;

export const validateEmail =
  (email, handleError) => (rule, value, callback) => {
    let error = "";
    if (!email) {
      error = "Email is required";
      callback(error);
    } else if (!emailRegex.test(email)) {
      error = "Invalid email address";
      callback(error);
    } else {
      error = "";
      callback();
    }
    handleError({ email: error });
  };

export const validateMobile =
  (mobile, handleError) => (rule, value, callback) => {
    let error = "";
    if (!mobile) {
      error = "Mobile is required";
      callback(error);
    } else if (!mobileRegex.test(mobile)) {
      error = "Invalid mobile";
      callback(error);
    } else {
      error = "";
      callback();
    }
    handleError({ mobile: error });
  };

  export const validateHomePincode = (homePincode, handleError) => (rule, value, callback) => {
    let error = "";
    if (!homePincode) {
      error = "Pincode is required";
      callback(error);
    } else {
      error = "";
      callback();
    }
    handleError({ homePincode: error });
};

  export const validateCity = (city, handleError) => (rule, value, callback) => {
    let error = "";
    if (!city) {
      error = "City is required";
      callback(error);
    } else if (!cityRegex.test(city)) {
      error = "Invalid city";
      callback(error);
    } else {
      error = "";
      callback();
    }
    handleError({ city: error });
};

export const validateAddressLine1 = (address, handleError) => (rule, value, callback) => {
    let error = "";
    if (!address) {
      error = "Address is required";
      callback(error);
    } else if (!addressRegex.test(address)) {
      error = "Invalid address";
      callback(error);
    } else {
      error = "";
      callback();
    }
    handleError({ addressLine1: error });
};

export const validateAddressLine2 = (address, handleError) => (rule, value, callback) => {
    let error = "";
     if(address && !addressRegex.test(address)) {
      error = "Invalid address";
      callback(error);
    } else {
      error = "";
      callback();
    }
    handleError({ addressLine2: error });
};

export const validateLandmark = (landmark, handleError) => (rule, value, callback) => {
    let error = "";
    if (landmark && !addressRegex.test(landmark)) {
      error = "Invalid landmark";
      callback(error);
    } else {
      error = "";
      callback();
    }
    handleError({ landmark: error });
};

export const validateAppointmentDate =
  (date, handleError) => (rule, value, callback) => {
    let error = "";
    if (!date) {
      error = "Date is required";
      callback(error);
    } else {
      error = "";
      callback();
    }
    handleError({ appointmentDate: error });
  };

export const pickerOptionsMinutes = (isLastHour = false, count = 2, startFrom = 30) => {
  const arrayValues = Array.from(Array(count), (_, i) => i * startFrom);
  if(isLastHour){
    return (
      <option key={`0`} value={`00`}>
        {`00`}
      </option>
    )
  }
  return arrayValues.map((src, index) => {
    const optionValue = src < 10 ? `0${src}` : `${src}`;
    return (
      <option key={count + src + index} value={optionValue}>
        {optionValue}
      </option>
    );
  });
};

export const pickerOptionsHours = (meridiem) => {
  const arrayValues =
    meridiem === PAGE_CONSTANTS?.MERIDIEM_AM
      ? PAGE_CONSTANTS?.TIME_CONFIG?.AM
      : PAGE_CONSTANTS?.TIME_CONFIG?.PM;
  return arrayValues;
};

export const getMinDate = (forCenter = false) => {
  const currentHour = moment().toDate().getHours();
  const addDays = currentHour < 15 ? 1 : 2;
  if(forCenter && moment().add(addDays,'days')?.day() === 0){
    return moment().add(addDays + 1,'days').toDate();
  }
  else{
    return moment().add(addDays,'days').toDate();
  }
}

export const getMaxDate = (forCenter = false) => {
  const currentHour = moment().toDate().getHours();
  const addDays = currentHour < 15 ? 7 : 8;
  const finalDays = forCenter ? addDays + 1 : addDays;
  if(forCenter && moment().add(finalDays,'days')?.day() === 0){
    return moment().add(finalDays + 1,'days').toDate();
  }
  else{
    return moment().add(finalDays,'days').toDate();
  }
}